/**
 * Circuito Recupero (bandeja de autorizaciones).
 *
 * Debe mantenerse alineado con RECUPERO_ACTIVIDADES / RECUPERO_PERFIL_KEY
 * del backend (api_obrasocial / solicitudes/constants/recupero.constants.ts).
 */

/** Actividades cuyo trámite pasa por gestión de Recupero antes de Auditoría Médica. */
export const RECUPERO_ACTIVIDADES = [
    '6622ac967ca9b502cd110b84', // Medicamentos
    '6622ad357ca9b502cd110bc2', // Empadronamiento medicación crónica
];

/** Perfil (perfil.key) habilitado para procesar las solicitudes del circuito Recupero. */
export const RECUPERO_PERFIL_KEY = 'RECUPEROSUR';
